import {
  getDivisionsAPI,
  getDistrictsAPI,
  getPoliceStationsAPI,
  getPostOfficesAPI,
} from '../adapter/adapter'

export function getDivisionsHelper() {
  let promise = new Promise(function (resolve, reject) {
    getDivisionsAPI()
      .then((res) => {
        console.log('getDivisionsAPI response:', res?.data)
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.code === 200 && res?.data?.data?.divisions) {
          resolve(res.data.data.divisions)
        } else if (res?.data?.data?.divisions) {
          resolve(res.data.data.divisions)
        } else {
          console.log('No divisions found in response')
          resolve([])
        }
      })
      .catch((err) => {
        console.log('Error fetching divisions:', err)
        reject('Failed to load divisions')
      })
  })

  return promise
}

export function getDistrictsHelper(divisionId) {
  let promise = new Promise(function (resolve, reject) {
    getDistrictsAPI(divisionId)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data?.districts) {
          resolve(res.data.data.districts)
        } else {
          resolve([])
        }
      })
      .catch((err) => {
        console.log('Error fetching districts:', err)
        reject('Failed to load districts')
      })
  })

  return promise
}

export function getPoliceStationsHelper(districtId) {
  let promise = new Promise(function (resolve, reject) {
    getPoliceStationsAPI(districtId)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data?.police_stations) {
          resolve(res.data.data.police_stations)
        } else {
          resolve([])
        }
      })
      .catch((err) => {
        console.log('Error fetching police stations:', err)
        reject('Failed to load police stations')
      })
  })

  return promise
}

export function getPostOfficesHelper(policeStationId) {
  let promise = new Promise(function (resolve, reject) {
    getPostOfficesAPI(policeStationId)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data?.post_offices) {
          resolve(res.data.data.post_offices)
        } else {
          resolve([])
        }
      })
      .catch((err) => {
        console.log('Error fetching post offices:', err)
        reject('Failed to load post offices')
      })
  })

  return promise
}
